<template>
  <div>
    <content-loader v-for="i in 3" :key="i" :height="60" :width="300">
      <rect x="2" y="0" width="70" height="2" />
      <rect x="2" y="30" width="70" height="2" />
      <rect x="0" y="0" width="2" height="32" />
      <rect x="70" y="0" width="2" height="32" />

      <circle cx="15" cy="16" r="11" />
      <rect x="30" y="10" width="30" height="4" />
      <rect x="30" y="16" width="30" height="4" />

      <rect x="85" y="0" width="50" height="5" />
      <rect x="85" y="8" width="30" height="3" />
      <rect x="85" y="15" width="215" height="17" />
    </content-loader>
  </div>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
